import { render, staticRenderFns } from "./chatAttachment.vue?vue&type=template&id=3de76d2c"
import script from "./chatAttachment.vue?vue&type=script&lang=js"
export * from "./chatAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports